import { useParams } from "react-router-dom";
import ServicePageLayout from "@/components/ServicePageLayout";
import { SERVICES } from "@/data/services";
import NotFound from "@/pages/NotFound";

export default function ServicePage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.serviceSlug;
  const data = SERVICES[slug];
  if (!data) return <NotFound />;
  return <ServicePageLayout {...data} />;
}
